import { JSX, useEffect, useState } from 'react';
import WorkIcon from '../../../src/assets/images/icons/tobacco.png';
import PersonalIcon from '../../../src/assets/images/icons/rainbow.png';
import ShoppingIcon from '../../../src/assets/images/icons/pool.png';
import BirthdayIcon from '../../../src/assets/images/icons/cake.png';
import DropdownIcon from '../../../src/assets/images/icons/caret-down.png';
import './category.css';
import CategoryDropdown from './categoryDropdown';

export type categories = 'Work' | 'Personal' | 'Shopping' | 'Birthday' | 'Uncategorized';

export interface categoryProps {
    text: string,
    type: categories,
    image: string,
}

interface categoryInputProps {
    category: categories;
    onCategoryChange: (category: categories) => void;
};

export const categoryOptions: categoryProps[] = [
    { text:'Work', type: 'Work', image: WorkIcon },
    { text:'Personal', type: 'Personal', image: PersonalIcon },
    { text:'Shopping', type: 'Shopping', image: ShoppingIcon },
    { text:'Birthday', type: 'Birthday', image: BirthdayIcon },
];

const Category = ({category, onCategoryChange}:categoryInputProps): JSX.Element => {

    const [selectedCategory, setNewCategory] = useState<categoryProps>(
        categoryOptions.find(option => option.type === category) || categoryOptions[0]);
    const [openDropdown, setOpenDropdown] = useState(false);

    useEffect(() => {
        onCategoryChange(selectedCategory.type);
    },[selectedCategory]);

    useEffect(() => {
        setNewCategory(categoryOptions.find(option => option.type === category) || categoryOptions[0]);
    },[category]);

    return (
      <div className='category-button-container'>
        <div className="category-container" onClick={()=>setOpenDropdown(!openDropdown)}>
            <img
                src={selectedCategory.image}
                className='category-icon'
                alt={'work icon'}
            />
            <img 
                src={DropdownIcon}
                className='dropdown-icon'
                alt={'dropdown icon'}
            />
            {openDropdown && <CategoryDropdown
            onCategorySelect={setNewCategory}
            onClose={() => setOpenDropdown(false)}
            />}
        </div>
      </div>
    ); 
};
    
export default Category;